import { Slider } from '../modules/slider';

const sections = document.querySelectorAll('.testimonials');

if (sections.length > 0) {
    sections.forEach(section => {
        const slider = new Slider({
            el: section,
            loop: false,
            blockLastSlides: true,
            breakpoints: {
                0: {
                    slidesPerView: 1.2,
                    marginRight: 8,
                },
                767: {
                    slidesPerView: 2,
                },
                992: {
                    slidesPerView: 2.25,
                    marginRight: 24,
                },
            },
        });
    });
}
